var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","justify":"center"}},_vm._l((_vm.testi),function(element,i){return _c('v-card',{key:i,class:`d-flex justify-start overflow-hidden wrapper-box`,attrs:{"max-width":"328","tile":"","flat":""}},[_c('ContentTestiMobile',{attrs:{"data":element}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }